module.exports = __webpack_public_path__ + "img/manual_2.e9d6a938.png";